import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { http, fmtErr } from "@/lib/api";
import BrandLogo from "@/components/BrandLogo";
import { KeyRound } from "lucide-react";

export default function OwnerSetupPage() {
  const nav = useNavigate();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("onlinetechai55@gmail.com");
  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pw1.length < 8) return setErr("Password must be at least 8 characters.");
    if (pw1 !== pw2) return setErr("Passwords do not match.");
    setBusy(true);
    try {
      await http.post("/auth/owner-setup", { token, email, new_password: pw1 });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e2) { setErr(fmtErr(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--surface)" }}>
      <div className="card w-full max-w-md">
        <div className="mb-6"><BrandLogo className="h-12" /></div>
        {done ? (
          <div className="text-center py-6" data-testid="owner-setup-success">
            <div className="font-serif text-3xl mb-3">Password saved</div>
            <p className="text-sm" style={{ color: "var(--muted)" }}>Taking you to the sign-in page…</p>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-2"><KeyRound size={18} style={{ color: "var(--terracotta)" }} /><h1 className="font-serif text-3xl">Owner Password Setup</h1></div>
            <p className="text-sm mb-6" style={{ color: "var(--muted)" }}>
              This page lets the property owner set or reset the Admin password without any technical tools.
              You need the one-time <b>setup code</b> (it looks like <code>FBN-…</code>). Each code works only once.
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="text-xs" style={{ color: "var(--muted)" }}>One-time setup code</label>
                <input data-testid="owner-setup-token" value={token} onChange={(e) => setToken(e.target.value)} placeholder="FBN-xxxxxxxx" required />
              </div>
              <div>
                <label className="text-xs" style={{ color: "var(--muted)" }}>Owner email</label>
                <input data-testid="owner-setup-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <div>
                <label className="text-xs" style={{ color: "var(--muted)" }}>New password (min 8 characters)</label>
                <input data-testid="owner-setup-password" type="password" value={pw1} onChange={(e) => setPw1(e.target.value)} required />
              </div>
              <div>
                <label className="text-xs" style={{ color: "var(--muted)" }}>Repeat new password</label>
                <input data-testid="owner-setup-password2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required />
              </div>
              {err && <div className="text-sm" style={{ color: "var(--terracotta)" }} data-testid="owner-setup-error">{err}</div>}
              <button data-testid="owner-setup-submit" type="submit" className="btn-primary w-full" disabled={busy}>{busy ? "Saving…" : "Set My Password"}</button>
            </form>
            <Link to="/login" data-testid="owner-setup-back" className="block text-center mt-6 text-sm" style={{ color: "var(--muted)" }}>← Back to sign in</Link>
          </>
        )}
      </div>
    </div>
  );
}
